import { IBudgetAnalysisReportService } from './budget.report.types'
import { ReportParameter } from '@/entities'
import { http } from '@/shared/https'

export class ImplementationProgressReportService implements IBudgetAnalysisReportService {

    /** Get the filters */
    getFilters(): any {
        return http.get('api/AllocationReport/GetFilter')
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        })
    }

    /** get the allocation report */
    generateReport(params: any): any {        
        let query = {
            "Size": 0,
            "Filters": params,
            "SortOrder": {
                "Field": "GrantCode"
            },
            "Aggregate": [
                {
                    "id": "Initiative",
                    "term": "groupby",
                    "type": "string"
                },
                {
                    "id": "Region",
                    "term": "groupby",
                    "type": "string"
                },
                {
                    "id": "Country",
                    "term": "groupby",
                    "type": "string"
                },
                {
                    "id": "GrantType",
                    "term": "groupby",
                    "type": "string"
                },
                {
                    "id": "ProjectTitle",
                    "term": "groupby",
                    "type": "string"
                },
                {
                    "id": "GrantCode",
                    "term": "groupby",
                    "type": "string"
                },
                {
                    "id": "Currency",
                    "term": "groupby",
                    "type": "string"
                },
                {
                    "id": "RequestedAmount",
                    "term": "groupby",
                    "type": "long"

                },
                {
                    "id": "GrantSignDate",
                    "term": "groupby",
                    "type": "date"

                },
                {
                    "id": "GrantClosingDate",
                    "term": "groupby",
                    "type": "date"

                },
                {
                    "id": "ReportBudget",
                    "nested": true,
                    "children": [                        
                        {
                            "id": "ReportBudget.Spent",
                            "term": "metrics",
                            "mOperator": "sum",
                            "type": "string",
                            "nested": true,
                            "parent": "ReportBudget"
                        },
                        {
                            "id": "ReportBudget.Forecast",
                            "term": "metrics",
                            "mOperator": "sum",
                            "type": "string",
                            "nested": true,
                            "parent": "ReportBudget"
                        },
                        {
                            "id": "ReportBudget.Budget",
                            "term": "metrics",
                            "mOperator": "sum",
                            "type": "string",
                            "nested": true,
                            "parent": "ReportBudget"
                        }
                    ]
                }
            ]
        };
        return http.post('api/ImplementationProgressReport', query ).then((resp: any) => {
            return resp;
        });
    }
}